<template>
  <form @submit.prevent="update">
    <div class="update-file-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Update File</p>
      </header>
      <section class="modal-card-body">
        <b-field label="File"></b-field>
        <b-field class="file">
          <figure class="image is-3by3 is-inline-block" style="padding:5px">
            <img
              class="file-image"
              v-if="file.mime.includes('image') && !imageError"
              :src="file.thumbnail"
              alt
              @error="imageLoadError"
              style="width: auto; height: 150px;"
            >
            <b-icon v-else :icon="getIconByMimeType(file.mime)" size="is-large"></b-icon>
          </figure>
          <br>
        </b-field>
        <b-field>
          <p class="has-text-weight-semibold">{{file.filename.replace(/^.*[\\\/]/, "")}}</p>
        </b-field>

          <br>

        <b-field label="Type" v-if="types">
          <b-select v-model="form.subtype" :disabled="!canManagedocuments">
            <option v-for="type in types" :value="type.value" :key="type.value">{{ type.label }}</option>
          </b-select>
        </b-field>

        <tags-input :label="'Tags'" :allowNew="true" @selectedTags="selectedTags" :values="form.tags" v-if="canManagedocuments"/>

        <p v-else>
          <br>
          <label class="label">Tags</label>
          <em v-for="(tag, key) in form.tags">#{{ tag }},</em>

          <br><br>
        </p>

        <b-field label="Description">
          <b-input type="textarea" v-model="form.description" :disabled="!canManagedocuments"></b-input>
        </b-field>

<!--
          <div v-if="canManagedocuments">

            <br>

            <b-field label="Select who you want to see this document?">

            </b-field>

            <div class="field">
                <b-checkbox v-model="form.viewers.colleagues">Colleagues</b-checkbox>
            </div>

            <div class="field">
                <b-checkbox v-model="form.viewers.customers">Customers</b-checkbox>
            </div>

            <div class="field">
                <b-checkbox v-model="form.viewers.vendors">Vendors</b-checkbox>
            </div>

          </div>
-->

      </section>

      <footer class="modal-card-foot">

        <b-button :disabled="loading" @click="$parent.close()">CANCEL</b-button>

        <b-button type="is-danger" :disabled="loading" :loading="deleting" @click.prevent="deleteConfirmation" v-if="canManagedocuments">Delete</b-button>

        <b-button type="is-info" native-type="submit" :loading="loading" v-if="canManagedocuments">UPDATE</b-button>

      </footer>

    </div>

  </form>

</template>

<script>
import { FileService } from "@/services/file.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import TagsInput from "@/components/partials/TagsInput";

export default {
  fileService: FileService,
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  components:{
    TagsInput
  },
  data: () => ({
    imageError: false,
    modal: {
      active: false
    },
    form: {
      type: "",
      description: "",
      tags: null
    },
    loading: false,
    deleting: false
  }),
  computed: {
    types() {
      return [
        {
          value: "Report",
          label: "Report"
        },
        {
          value: "Photo",
          label: "Photograph"
        },
        {
          value: "Checklist",
          label: "Checklist"
        },
        {
          value: "Site Notes",
          label: "Site Notes"
        }
      ];
    },

    canManagedocuments() {

      return this.$store.getters["Auth/hasPermission"]("can manage documents");

    }


  },
  created() {
    this.setForm();
  },
  methods: {
    imageLoadError(event) {
      this.imageError = true;
    },
    selectedTags(tags){
      this.form.tags = tags
    },
    setForm() {
      this.form = {
        subtype: this.file.subtype,
        description: this.file.description,
        tags: this.file.tags.map(tag => {
          return tag.name;
        }),

        viewers: this.file.viewers

      };
    },
    async update() {

      this.loading = true;

      try {
        let file = await this.$options.fileService
          .update(this.file.id, this.form)
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "File has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        this. file.description = file.description
        this. file.subtype = file.subtype
        this. file.tags = file.tags

        this.$emit('update', file)

        this.$parent.close();
      } catch (rrr) {}

      this.loading = false;
    },
    deleteConfirmation(){
      this.$buefy.dialog.confirm({
          title: 'Deleting file',
          message: 'Are you sure you want to <b>delete</b> this file? This action cannot be undone.',
          confirmText: 'Delete Account',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.deleteFile()
      })
    },
    async deleteFile(){
      this.deleting = true
      await this.$options.fileService.delete(this.file.id)
        .then(response => {
          this.$buefy.toast.open('File deleted!')
          this.$emit('deleteFile', this.file)
          this.deleting = false
          this.$parent.close();
        }).catch(err =>{
          this.deleting = false
        })

    },
    getIconByMimeType(mime) {
      if (mime.includes("image")) {
        return "file-image-o";
      } else if (mime.includes("pdf")) {
        return "file-pdf-o";
      } else if (mime.includes("msword") || mime.includes("word")) {
        return "file-word-o";
      } else if (mime.includes("zip") || mime.includes("rar")) {
        return "file-archive-o";
      } else if (mime.includes("ms-excel") || mime.includes("sheet")) {
        return "file-excel-o";
      } else if (
        mime.includes("ms-powerpoint") ||
        mime.includes("presentation")
      ) {
        return "file-powerpoint-o";
      } else if (mime.includes("text/plain")) {
        return "file-text-o";
      } else {
        return "file";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Documents/File/FileUpdate.vue